import {  InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError,  errorHandler, ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages';
import { ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Logger, Get, UseGuards,Req} from '@nestjs/common';
import { SoakingService } from './soaking.service';
import { AllSoakingResponseModel, AssignSoakingDto, assignSoakingForFreezingResponse, BeheadingInventoryResponse, JobCompletedStatusDto, LotDetailsResponseModel, ReportSoakingRequest, SoakingDetailsRequest, SoakingDetailViewResponseModel, SoakingDto, SoakingResponseModel, SoakingStatusWiseResponseModel, workstationsStatusResponseModel } from '@gtpl/shared-models/production-management';
import { UnitRequest } from './dto/unit.id.request';
import { ProductionLogService } from './production-log.service';
import { LogIdRequest } from './dto/log-id-request';

@ApiTags('soaking')
@Controller('soaking')
export class SoakingController {
    constructor(
        private logService:ProductionLogService,
        private soakingService: SoakingService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){}

    // @Post('/assignSoakingForFreezing')
    // async assignSoakingForFreezing(@Body() soakingInfo: JobCompletedStatusDto): Promise<assignSoakingForFreezingResponse>  {
    //     try {
    //         return await this.soakingService.assignSoakingForFreezing(soakingInfo);
    //     } catch (error) {
    //         return this.applicationExceptionHandler.returnException(assignSoakingForFreezingResponse, error);
    //     }
    // }

    @Post('/reportSoakingAssignment')
    async reportSoakingAssignment(@Body() inputReq: ReportSoakingRequest): Promise<assignSoakingForFreezingResponse> {
        try {
            return await this.soakingService.reportSoakingAssignment(inputReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(assignSoakingForFreezingResponse, error);
        }
    }
    @Post('/createSoakingAssignment')
    async createSoakingAssignment(@Body() inputReq: AssignSoakingDto): Promise<assignSoakingForFreezingResponse> {
        try {
            return await this.soakingService.createSoakingAssignment(inputReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(assignSoakingForFreezingResponse, error);
        }
    }

    // @Post('/jobCompletedStatus')
    // async jobCompletedStatus(@Body() soakingInfo: SoakingDto): Promise<assignSoakingForFreezingResponse>  {
    //     try {
    //         return await this.soakingService.jobCompletedStatus(soakingInfo);
    //     } catch (error) {
    //         return this.applicationExceptionHandler.returnException(assignSoakingForFreezingResponse, error);
    //     }
    // }

    @Post('/getAllSoakingAssignments')
    async getAllSoakingAssignments(@Body() plantReq: UnitRequest): Promise<SoakingResponseModel> {
        try {
            return await this.logService.getAllSoakingInfo(plantReq);
        } catch (error) {
            return error;
        }
    }
    
    @Post('/getLotDetailsById')
    async getLotDetailsById(@Body() logReq: LogIdRequest): Promise<LotDetailsResponseModel> {
        console.log(logReq.productionLogid);
        try {
            return await this.logService.getLotDetailsById(logReq);
        } catch (error) {
            return error;
        }
    }
    @Post('/getInProgressWorkstations')
    async getInProgressWorkstations(@Body() plantReq: UnitRequest): Promise<workstationsStatusResponseModel> {
        try {
            return await this.soakingService.getInProgressWorkstations(plantReq);
        } catch (error) {
            return error;
        }
    }

    @Post('/getsoakingStatusWiseDetails')
    async getsoakingStatusWiseDetails(@Body() plantReq: UnitRequest): Promise<SoakingStatusWiseResponseModel> {
        try {
            return await this.soakingService.getsoakingStatusWiseDetails(plantReq);
        } catch (error) {
            return error;
        }
    }
    @Post('/getSoakingDataById')
    async getSoakingDataById(@Body() soakingDetailsRequest: SoakingDetailsRequest): Promise<SoakingDetailViewResponseModel> {
        try {
            return await this.soakingService.getSoakingDataById(soakingDetailsRequest);
        } catch (error) {
            return error;
        }
    }


    // @Post('/getAllSoakingInventoryInfo')
    // async getAllSoakingInventoryInfo(@Body() plantReq: UnitRequest): Promise<AllSoakingResponseModel>  {
    //     try {
    //         return await this.soakingService.getAllSoakingInventoryInfo(plantReq.unitId);
    //     } catch (error) {
    //         return this.applicationExceptionHandler.returnException(AllSoakingResponseModel, error);
    //     }
    // }


    @Post('/createSoakingAssignmentForV2')
    async createSoakingAssignmentForV2(@Body() inputReq: AssignSoakingDto): Promise<assignSoakingForFreezingResponse> {
        try {
            return await this.soakingService.createSoakingAssignmentForV2(inputReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(assignSoakingForFreezingResponse, error);
        }
    }



}
